import React from 'react'
import { Control, useController } from 'react-hook-form'
import { ResultsSearchValues, AnalyzerFilterType } from '../types'
import './AnalyzerTypeSelector.css'

const ANALYZER_TYPE_OPTIONS: Array<{
  label: string
  value: AnalyzerFilterType
}> = [
  { label: 'Manual Results', value: 'manual' },
  { label: 'Ingress Results', value: 'ingress' }
]

type AnalyzerTypeSelectorProps = {
  control: Control<ResultsSearchValues>
  name: keyof ResultsSearchValues
}

const AnalyzerTypeSelector: React.FC<AnalyzerTypeSelectorProps> = ({
  control,
  name
}) => {
  const {
    field: { value, onChange }
  } = useController({
    name: name as keyof ResultsSearchValues,
    control,
    rules: {
      required: true
    }
  })

  const handleClick = (optionValue: AnalyzerFilterType) => {
    onChange(optionValue)
  }

  return (
    <div
      className="resultsPage-analyzer-type-buttons"
      role="tablist"
      aria-label="Analyzer type selection"
    >
      {ANALYZER_TYPE_OPTIONS.map((option) => {
        const isActive = value === option.value
        const buttonClassName = isActive
          ? 'resultsPage-analyzer-type-button resultsPage-analyzer-type-button--active'
          : 'resultsPage-analyzer-type-button'

        return (
          <button
            key={option.value}
            type="button"
            className={buttonClassName}
            role="tab"
            aria-selected={isActive}
            onClick={() => handleClick(option.value)}
            tabIndex={isActive ? 0 : -1}
          >
            {option.label}
          </button>
        )
      })}
    </div>
  )
}

export default AnalyzerTypeSelector
